<template>
    <div>
        <!-- Home Section -->
        <section id="home">
            <section id="xslider" class="contain">
                <div class="txp-banner">
                    <img :src="baseUrl + '/assets/images/banner1.jpg'" alt="slidebg1" data-bgfit="cover"
                        data-bgposition="left top" data-bgrepeat="no-repeat" style="width: 100%" />
                </div>
            </section>
        </section>
        <!-- End Home Section -->

        <section id="Media" class="contain ">
            <div class="inner">
                <div class="header margin-10px-bottom">
                    <span>Media Interviews</span>
                </div>
                <form action="#">
                    <div class="survey-box">
                        <div id="q1" class="survey">
                            <div class="q">1) Would you be interested in participating in a media interview?</div>
                            <div class="as">
                                <input type="radio" id="q1-a1" name="q1">
                                <label for="q1-a1" class="a">Yes</label>

                                <input type="radio" id="q1-a2" name="q1">
                                <label for="q1-a2" class="a">NO</label>
                            </div>
                        </div>

                        <div id="q2" class="survey">
                            <div class="q">2) Please Select your media preference from the drop-down list [we need
                                to make sure they can select a couple of media at the same time]</div>
                            <div class="as">
                                <select class="a">
                                    <option value="">choose your answer</option>
                                    <option value="Argaam">Argaam</option>
                                    <option value="Forbes Middle East">Forbes Middle East</option>
                                    <option value="Bloomberg">Bloomberg</option>
                                    <option value="Gulf Business">Gulf Business</option>
                                </select>

                                <!-- <input type="radio" id="q2-a1" name="q2">
									<label for="q2-a1" class="a">Argaam</label>

									<input type="radio" id="q2-a2" name="q2">
									<label for="q2-a2" class="a">Forbes Middle East</label>

									<input type="radio" id="q2-a3" name="q2">
									<label for="q2-a3" class="a">Bloomberg</label>

									<input type="radio" id="q2-a4" name="q2">
									<label for="q2-a4" class="a">Gulf Business</label> -->


                            </div>
                        </div>

                        <button type="submit"> Submit </button>
                    </div>
                </form>
            </div>
            <div class="header margin-10px-bottom">
                <span>coverage</span>
            </div>

            <div class="flex-boxes">
                <!-- if link -->
					<a class="box" href="#" target="_blank">
						<div class="title">19 September 2022 - Economy Middle East</div>
						<div class="description">EFG Hermes Holding hosts its 16<sup>th</sup> One-on-One Conference in Dubai</div>
					</a>
					<!-- if link -->
					<div class="box">
						<div class="title">19 September 2022 - Mubasher </div>
						<div class="description">EFG Hermes Holding hosts its 16<sup>th</sup> One-on-One Conference in Dubai</div>
					</div>
					<div class="box">
						<div class="title">19 September 2022 - Al Bayan</div>
						<div class="description">55 Global Investors from 37 Countries Participate in EFG Hermes
							Holding's One on One Conference in Dubai</div>
					</div>
					<div class="box">
						<div class="title">19 September 2022 - Economy Middle East</div>
						<div class="description">655 Global Investors from 37 Countries Participate in EFG Hermes Holding's One on One  Conference in Dubai
						</div>
					</div>
					<div class="box">
						<div class="title">19 September 2022 - Gulf News</div>
						<div class="description">EFG Hermes Holding Hosts its 16<sup>th</sup> Annual One on 
							One Conference in Dubai Today
						</div>
					</div>
					<div class="box">
						<div class="title">19 September 2022 - Emarat Alyoum</div>
						<div class="description">EFG Hermes Holding Hosts 16<sup>th</sup> Annual Conference in Dubai
						</div>
					</div>
					<div class="box">
						<div class="title">19 September 2022 - Gulf Today</div>
						<div class="description">EFG to Unlock Prospects for Global Investors

						</div>
					</div>
					<div class="box">
						<div class="title">19 September 2022 - Forbes Middle East</div>
						<div class="description">EFG Hermes Event to Connect Global Investors 
							to Opportunities in MENA

						</div>
					</div>
					<div class="box">
						<div class="title">19 September 2022 - Entrepreneur Al Arabiya</div>
						<div class="description">EFG Hermes Holding Hosts its 16<sup>th</sup> Annual One on One Conference, the World's Largest Frontier Emerging Markets Conference, in Dubai Today


						</div>
					</div>
					<div class="box">
						<div class="title">22 September 2022 - Khaleej Times</div>
						<div class="description">EFG Hermes Conference to Explore Investment 
							Options in the MENA Region

						</div>
					</div>
					<div class="box">
						<div class="title">19 September 2022 - Zawya</div>
						<div class="description">EFG Hermes Holding's 16<sup>th</sup> Annual One on One Conference, the Largest Frontier Emerging Markets Conference, Kicks off in Dubai Today

						</div>
					</div>
            </div>

            <div class="header margin-10px-bottom">
                <span>Photo Gallery</span>
            </div>

            <div class="galleries">
                <div class="gallery">
                    <div class="gallery-image">
                        <img :src="baseUrl + '/assets/images/re.png'" alt="image">
                    </div>
                    <div class="gallery-description">The opening speech delivered by EFG Hermes Holding Group
                        CEO Karim Awad</div>
                </div>

                <div class="gallery">
                    <div class="gallery-image">
                        <img :src="baseUrl + '/assets/images/re.png'" alt="image">
                    </div>
                    <div class="gallery-description">EFG Hermes - The 16<sup>th</sup> Annual One on  One Conference Highlights</div>
                </div>
                <div class="gallery">
                    <div class="gallery-image">
                        <img :src="baseUrl + '/assets/images/re.png'" alt="image">
                    </div>
                    <div class="gallery-description">Simon Kitchen, MD and Head of Strategy at EFG Hermes Research, interviewing H.E. Helal Almarri, Director General of Dubai's Department of Economy and Tourism, member of the Executive Council of Dubai, board member at the Investment Corporation of Dubai, Director General of the Dubai World Trade Centre Authority (DWTCA), and Chairman of Dubai Financial Market</div>
                </div>

            </div>
            <!-- End inner div -->
        </section>
    </div>
</template>

<script>
export default {
    data: () => ({
        baseUrl: window.location.origin,
    }),
}
</script>

<style></style>